import React from "react";
import { whatsappNumber, whatsappMessage } from "../../data/siteData";
import "./Hero.css";

function Hero() {
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
    whatsappMessage
  )}`;

  return (
    <section className="hero" id="inicio">
      <div className="hero__overlay" />

      <div className="hero__container">
        <div className="hero__content">
          <span className="hero__tag">Fornecedor B2B para restaurantes</span>

          <h1>Sobremesas prontas para aumentar o ticket médio do seu Rodizio japonês</h1>

          <p>
            Frozen yogurt e sorvetes de 10 litros pensados para restaurantes que querem vender mais
            sobremesas com operação simples, boa margem e alta aceitação.
          </p>

          <div className="hero__actions">
            <a href={whatsappLink} target="_blank" rel="noreferrer" className="btn-whatsapp">
              Quero colocar no cardápio
            </a>

            <a href="#produtos" className="hero__secondary">
              Ver produtos
            </a>
          </div>
        </div>

        <div className="hero__image-card">
        <img
  src="/home/home.png"
  alt="Sobremesa para restaurante japonês"
/>ƒ          <div className="hero__badge">
            <strong>Pronto para vender</strong>
            <span>Entrega rápida e pedido mínimo B2B</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;